import applePayLogo from '../assets/logo-apple-pay.svg';
import creditCardIcon from '../assets/icon-credit-card.svg';

interface PaymentButtonsProps {
  applePayAvailable: boolean;
  onApplePay: () => void;
  onCard: () => void;
}

export function PaymentButtons({ applePayAvailable, onApplePay, onCard }: PaymentButtonsProps) {
  return (
    <div className="flex flex-col gap-2">
      {applePayAvailable && (
        <button
          type="button"
          onClick={onApplePay}
          className="flex h-[52px] w-full items-center justify-center gap-1 rounded-full bg-mf-neutral-900 text-base font-bold text-white transition-opacity hover:opacity-90"
        >
          <span>Buy with</span>
          <img src={applePayLogo} alt="Apple Pay" className="h-5 w-12" />
        </button>
      )}
      <button
        type="button"
        onClick={onCard}
        className="flex h-[52px] w-full items-center justify-center gap-1 rounded-full bg-mf-green text-base font-bold text-white transition-opacity hover:opacity-90"
      >
        <img src={creditCardIcon} alt="" className="size-6" />
        Credit or debit card
      </button>
    </div>
  );
}
